




















import { useLazyLoading } from '@a/helper/lazy-loading';
import {
  defineComponent, onMounted, onUnmounted,
} from '@vue/composition-api';
import OrderNowBar from '../../component/landingpage/OrderNowBar.vue';
import { useConfigurationApi } from '@a/plugins/configuration';
import { LandingPageItem } from '@a/store/landingpage/types';
import OrderWidget from '@c/landingpage/orderwidget/OrderWidget.vue';
import OrderWidgetModern from '@c/landingpage/orderwidget/modern/OrderWidgetModern.vue';
import BaseModpack from '@c/landingpage/modpack/BaseModpack.vue';
import i18next from 'i18next';

export default defineComponent({
  name: 'TheLandingpageView',
  components: {
    // --- above the fold components
    OrderNowBar,
    OrderWidget,
    OrderWidgetModern,
    BaseModpack,
    // --- below the fold components
    BaseGallery: () => import(/* webpackChunkName: "vue.landingpage.modern" */ '@c/ui/gallery/BaseGallery.vue'),
    ScrollToTopButton: () => import(/* webpackChunkName: "vue.landingpage.modern" */'@c/ui/button/ScrollToTopButton.vue'),
    LandingPageGallery: () => import(/* webpackChunkName: "vue.landingpage.modern" */'@c/landingpage/LandingPageGallery.vue'),
  },
  created: async () => {
    await i18next.loadNamespaces('extension');
  },
  setup: () => {
    const { data } = useConfigurationApi();
    const { setupLazyLoading, destroyLazyLoading } = useLazyLoading();

    onMounted(() => {
      setupLazyLoading();
    });

    onUnmounted(() => {
      destroyLazyLoading();
    });

    return {
      landingPageData: data.pageData as LandingPageItem,
    };
  },
});
